import React, { useState, useEffect } from "react";
import VerticalCategories from "./VerticalCategories";
import axiosInstance, { CMS_BASE_URL } from "../../../../../axios";
import PatientLoader from "../../../../common/PatientLoader";
import HorizontalMediaType from "./HorizontalMediaType";
import ContentTile from "./ContentTile";
import { normalizeMediaType, CMS_SLUG_TO_LABEL } from "../../../../../util/helpers";

const PinNewContentV2 = ({ patientID }) => {
  const [formattedData, setFormattedData] = useState([]);
  const [content, setContent] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [media, setMedia] = useState([
    {
      label: "Videos",
      value: "Videos",
    },
    {
      label: "Audio",
      value: "Audio",
    },
    
    {
      label: "Article",
      value: "Article",
    },
  ]);

  //* Selected Data Section
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [currentTab, setCurrentTab] = useState(1);
  const [selectedContent, setSelectedContent] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [cachedData, setCachedData] = useState({});

  const LANGUAGE_OPTIONS = [
    { label: "English", value: "en" },
    { label: "Español", value: "es" },
  ];

  const curatePinnedContent = async (category, lang) => {
    const res = await axiosInstance.get(`${CMS_BASE_URL}/content-type/${category}/`, {
      headers: { Authorization: `JWT ${localStorage.access}` },
      params: { language: lang },
    });
    const items = (res?.data || []).map((item) => {
      if (!item.media_type) {
        if (category === "videos") {
          item.media_type = "videos";
        } else if (category === "view-medicas") {
          item.media_type = "view-medicas";
        }
      }
      return item;
    });
    return { [category]: items };
  };

  const MEDIA_LOOKUP = {
    1: media[0],
    2: media[1],
    3: media[2],
  };


  useEffect(() => {
    setSelectedMedia(MEDIA_LOOKUP[currentTab]);
  }, [currentTab]);

  const handlePinnedContentFormatting = async (lang = "en") => {
    if (cachedData[lang]) {
      setFormattedData(cachedData[lang].formattedData);
      setData(cachedData[lang].data);
      return;
    }

    setLoading(true);
    try {
      const final = [];
      let unformatted = [];
      for (const key of Object.keys(CMS_SLUG_TO_LABEL)) {
        try {
          let temp = await curatePinnedContent(key, lang);
          if (temp && temp[key]) {
            unformatted = unformatted.concat([...temp[key]]);
            final.push(temp);
          }
        } catch (err) {
          console.error(`Error curating content for category ${key}:`, err);
        }
      }
      setFormattedData(final);
      setData(unformatted);
      setCachedData((prev) => ({
        ...prev,
        [lang]: {
          data: unformatted,
          formattedData: final,
        },
      }));
    } catch (e) {
      console.log("Error fetching content: ", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handlePinnedContentFormatting("en");
  }, []);

  const handleLanguageChange = (lang) => {
    setSelectedLanguage(lang);
    handlePinnedContentFormatting(lang);
  };

  useEffect(() => {
    const tempCategories = [];
    const seenItems = {};
    const tempContent = [];
    const filteredData = data.filter((item) => {
      const appType = item?.app_type?.App;
      if (process.env.REACT_APP_DASHBOARD_TYPE === "youth"){
        return appType !== "Adult" ;
      }else {
        return appType !== "Youth" ;
      }
      
    });
    // console.log("filteredData: " ,filteredData);
    for (const item in filteredData) {
      const name = filteredData[item]?.classification?.Name;
      if (name?.length > 0 && !(name in seenItems)) {
        seenItems[name] = 1;
        tempCategories.push({
          label: name,
          value: name,
        });
      }

      tempContent.push({
        label: filteredData[item]?.Title,
        value: filteredData[item],
      });
    }

    setCategories([...tempCategories]);
    setContent([...tempContent]);
  }, [formattedData, data]);

  useEffect(() => {
    if (categories.length) {
      setSelectedCategory(categories[0]);
      setSelectedMedia(media[0]);
    }
  }, [categories]);

  useEffect(() => {
    if (selectedCategory && selectedMedia) {
      const temp = [];
      let filteredTempData = [];
      data.forEach((content) => {     
        if (
          normalizeMediaType(content?.media_type) === selectedMedia?.label &&
          content?.classification?.Name === selectedCategory?.label
        ) {
          //*Doing a return was returning the item itself and not the desired structure even after modifications, hence the array push.
          temp.push({
            label: content?.Title,
            value: content,
          });
        }
      });
      filteredTempData = temp.filter((item) => {
        const appType = item?.value?.app_type?.App;
        if (process.env.REACT_APP_DASHBOARD_TYPE === "youth"){
          return appType !== "Adult" ;
          } else {
            return appType !== "Youth";
          }
      });
      // console.log("temp: ", temp);
      // console.log("filteredTempData: ", filteredTempData);
      setContent(filteredTempData);
    }
  }, [selectedCategory, selectedMedia]);

  return (
    <div className="container-fluid p-2 my-3">
      {loading ? (
        <PatientLoader />
      ) : (
        <div className="row">
          <div className="col-sm-3 col-md-3 col-lg-3">
            <VerticalCategories
              categories={categories}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
            />
          </div>
          <div
            className="col-sm-9 col-md-9 col-lg-9"
            style={{ borderLeft: "1px solid lightgray" }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="mb-0">{selectedCategory && selectedCategory?.value}</h4>
              <div className="d-flex align-items-center">
                <label className="mb-0" style={{ fontSize: "0.9rem", color: "gray", marginRight: "8px" }}>Language:</label>
                <select
                  value={selectedLanguage}
                  onChange={(e) => handleLanguageChange(e.target.value)}
                  className="form-select form-select-sm"
                  style={{
                    width: "120px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    padding: "4px 8px",
                    fontSize: "0.9rem",
                    cursor: "pointer",
                    outline: "none"
                  }}
                >
                  {LANGUAGE_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <HorizontalMediaType
              currentTab={currentTab}
              setCurrentTab={setCurrentTab}
            />
            <div
              className="row container-fluid w-100 my-2 py-2"
              style={{ height: "60dvh", overflowY: "scroll" }}
            >
              {content?.length > 0 &&
                content?.map((data, index) => {
                  return (
                    <div className="col-sm-12 col-md-4 col-lg-4" key={index}>
                      <ContentTile content_data={data} patientID={patientID} />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PinNewContentV2;
